import { render, staticRenderFns } from "./appointmentDialogDetails.vue?vue&type=template&id=40c55cbe&"
import script from "./appointmentDialogDetails.vue?vue&type=script&lang=js&"
export * from "./appointmentDialogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports